import { render, staticRenderFns } from "./UiPoll.vue?vue&type=template&id=1786f102&"
import script from "./UiPoll.vue?vue&type=script&lang=js&"
export * from "./UiPoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports